import React from 'react';
import { getBranch } from 'services/storages/userStorage';
import { isBlockedBranch } from 'utils/blockBranch';
import 'styles/block-v1-branch-overlay.scss';

const PMS_V2_URL = process.env.REACT_APP_PMS_V2_URL || 'https://pms.kinex.ai/';

interface Props {
  top?: number | string;
}

const BlockV1BranchOverlay: React.FC<Props> = ({ top }) => {
  if (!isBlockedBranch(getBranch())) return null;

  return (
    <div
      className="blockV1BranchOverlay"
      style={top != null ? { top } : undefined}
      role="dialog"
      aria-modal="true"
      aria-labelledby="block-v1-branch-overlay-message"
    >
      <div className="blockV1BranchOverlay__content">
        <p className="blockV1BranchOverlay__message" id="block-v1-branch-overlay-message">
          This property is now on PMS v2. Please use the new version to continue.
        </p>
        <a
          className="blockV1BranchOverlay__link"
          href={PMS_V2_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          {PMS_V2_URL}
        </a>
      </div>
    </div>
  );
};

export default BlockV1BranchOverlay;
